// extracted by mini-css-extract-plugin
export var bounce = "_o7-1";
export var generatingText = "_o7-6";
export var lightning = "_o7-4";
export var popup = "_o7-5";
export var progressBar = "_o7-7";
export var progressFill = "_o7-8";
export var progressShimmer = "_o7-9";
export var progressText = "_o7-a";
export var shimmer = "_o7-3";
export var uploadIcon = "_o7-0";
export var uploadingText = "_o7-2";